import React, { useEffect } from 'react';
import { Row, Alert, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import MainCard from '../widgets/MainCard';

function HomePage({ firebaseUser, employee = {}, onLogin, loginError }) {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "QuickHub";
    }, []);

    return (
        <>
            {loginError && <Alert variant="danger">{loginError}</Alert>}
            {firebaseUser ? (
                <>
                    <h1>
                        <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo" width="380" />
                    </h1>

                    <h2 className='mt-5'>日常業務</h2>
                    <Row className='mt-4'>
                        {/* 管理者と一般ユーザーのみ */}
                        {employee?.role < 3 && (
                            <>
                                <MainCard
                                    header="デイレポ"
                                    description="なんでもつぶやこう"
                                    path="dayrepo"
                                    ext="svg"
                                    onClick={() => {
                                        navigate('report/dayrepo');
                                    }}
                                />
                                <MainCard
                                    header="ウィーレポ"
                                    description="週報の作成と共有"
                                    path="weerepo"
                                    ext="svg"
                                    onClick={() => {
                                        navigate('report/weerepo');
                                    }}
                                />
                            </>
                        )}
                        <MainCard
                            header="スキルシート"
                            description="スキルシート 登録・生成"
                            path="skill"
                            ext="svg"
                            onClick={() => {
                                navigate('skill');
                            }}
                        />
                        <MainCard
                            header="従業員一覧"
                            description="従業員情報を確認"
                            path="employee"
                            ext="svg"
                            onClick={() => {
                                navigate('employee');
                            }}
                        />

                    </Row>
                    <h2 className='mt-5'>勤怠</h2>
                    <Row className='mt-4'>
                        <MainCard
                            header="勤怠連絡"
                            description="休暇・出社の連絡"
                            path="attendance"
                            ext="svg"
                            onClick={() => {
                                navigate('request/attendance');
                            }}
                        />
                        <MainCard
                            header="営業日確認"
                            description="直近の営業日を確認"
                            path="calendar"
                            ext="svg"
                            onClick={() => {
                                navigate('holiday/businessDays');
                            }}
                        />
                        <MainCard
                            header="祝日管理"
                            description="祝日・会社休日の管理"
                            path="schedule"
                            ext="svg"
                            onClick={() => {
                                navigate('holiday/closedDays');
                            }}
                        />
                    </Row>

                    <h2 className='mt-5'>申請</h2>
                    <Row className='mt-4'>
                        <MainCard
                            header="健康診断"
                            description="健康診断希望日の申請"
                            path="health"
                            ext="svg"
                            onClick={() => {
                                navigate('request/health-check');
                            }}
                        />
                        <MainCard
                            header="書籍購入"
                            description="書籍購入の申請"
                            path="book"
                            ext="svg"
                            onClick={() => {
                                navigate('request/book');
                            }}
                        />
                    </Row>

                    <h2 className='mt-5'>確認</h2>
                    <ListGroup className='mt-3' as="ol" numbered>
                        <ListGroup.Item
                            target="_blank"
                            action href="https://payroll.moneyforward.com/"
                            rel="noopener noreferrer"
                        >
                            給与明細
                        </ListGroup.Item>
                        <ListGroup.Item
                            target="_blank"
                            action href="https://2f45a90d7a1eca3567c3ab9b.smarthr.jp/"
                            rel="noopener noreferrer"
                        >
                            従業員情報
                        </ListGroup.Item>
                    </ListGroup>
                </>
            ) : (
                <div className='text-center'>
                    <p>サービスのご利用にはログインが必要です。</p>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/google_sign_in.png`}
                        onClick={onLogin}
                        alt="Google Sign In"
                        className='image-button mt-3 mb-5'
                        style={{ cursor: 'pointer' }}
                        width='260'
                    />
                </div>
            )}
        </>
    );
}

export default HomePage;
